export const parseDocStatus = (score: number) => {
  if (score < 50) return "Rejected";
  if (score <= 70) return "Warning";
  if (score > 70) return "Accepted";
};
